import type { HeadingData } from 'ricos-schema';
import { Node_Type } from 'ricos-schema';

import { text } from './common-plugins.builder';
import type { NodeBuilder, TextNodeBuilder } from './types';
import { isDefined } from './utils';

export const heading = (...args: (string | TextNodeBuilder | HeadingData)[]): NodeBuilder => {
  const headingData = args.find((a): a is HeadingData => typeof a !== 'string' && !('type' in a));
  return {
    type: 'block_node',
    node: getId => ({
      id: getId(),
      type: Node_Type.HEADING,
      nodes: args
        .map(arg =>
          typeof arg === 'string'
            ? text(arg).node()
            : 'type' in arg && arg.type === 'text_node'
            ? arg.node()
            : undefined
        )
        .filter(isDefined),
      headingData: headingData ? headingData : undefined,
    }),
  };
};
